import { render, staticRenderFns } from "./WorkModal.vue?vue&type=template&id=1b8117f4"
import script from "./WorkModal.vue?vue&type=script&lang=js"
export * from "./WorkModal.vue?vue&type=script&lang=js"
import style0 from "./WorkModal.vue?vue&type=style&index=0&id=1b8117f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports